import './Checkbox.css'

export function Checkbox({ checked, onChange, children, style, ...rest }) {
  return (
    <label className="u-check" style={style}>
      <input type="checkbox" checked={checked} onChange={onChange} {...rest} />
      <span className="u-box">
        <svg
          width="12"
          height="12"
          viewBox="0 0 24 24"
          fill="none"
          stroke="#fff"
          strokeWidth="3.5"
          strokeLinecap="round"
          strokeLinejoin="round"
          aria-hidden="true"
        >
          <path d="M20 6 9 17l-5-5" />
        </svg>
      </span>
      <span>{children}</span>
    </label>
  )
}

export default Checkbox
